export enum MediaItemViewType {
  SIMPLE_ITEM_VIEW = "simple-item-view",
  AGGREGATED_ITEM_VIEW = "aggregated-item-view",
}
